<app-list-view
  [column]="column"
  [data]="inspections"
  [count]="this.count"
  [title]="'Inspections'"
  [url]="url"
  [loading]="loading"
  [hideTabs]="false"
  [SearchPlaceholder]="'Filter by Customer or Policy'"
  [setInspectionSearch]="true"
  [canEdit]="canAdd"
  [showAction]="true"
  [tabType]="'rejected'"
  [actions]="actions"
  [tableName]="'inspectionRejected'"
  (filters)="loadData($event)"></app-list-view>
